package com.patronat.top.client.domain.reviews

import com.patronat.top.client.data.reviews.ClientReviewsRepository
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.ReviewSummaryResponse

class GetClientReviewSummaryUseCase(
    private val repository: ClientReviewsRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<String, DomainResult<ReviewSummaryResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: String): DomainResult<ReviewSummaryResponse> {
        return repository.getVenueReviewSummary(command)
    }
}
